import { render, staticRenderFns } from "./AccessConcessions.vue?vue&type=template&id=b524f2c0"
import script from "./AccessConcessions.vue?vue&type=script&lang=js"
export * from "./AccessConcessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports